// Common
import config from '@/config.js';

// let baseURL = "http://api.new.com/";// 本地测试环境接口域名
// let baseURL = "http://api.new.com/";// 本地测试环境接口域名
// let baseURL = "https://test.api.v1.yywd.vip/";// 云端测试环境接口域名
let baseURL = "https://test.api.ent.yywd.vip/";// 云端测试环境接口域名
// let baseURL = "https://api.v1.yywd.vip/";// 正式服
let oldPlatform = "http://test.yywd.vip/";// 老项目地址
// let baseURL = "https://huawei.api.v1.yywd.vip/";// 华为云端测试环境接口域名
if (window.location.host.startsWith('supplier.yywd.vip')) {
    config.debug = false;
    baseURL = "https://api.v1.yywd.vip/";// 生产环境接口域名
    oldPlatform = "https://ssl.yywding.cn/";// 生产环境老项目地址
} else if (window.location.host.startsWith('sanlian.supplier.yywd.vip')) {
    config.debug = false;
    baseURL = 'https://sanlian.api.v1.yywd.vip/' // 三联独立部署接口域名  
} else if (window.location.host.startsWith('supplier.jicainiao.com')) {
    config.debug = false;
    baseURL = 'https://admin.jicainiao.com/' // 三联独立部署接口域名
} else if (window.location.host.startsWith('huawei.supplier.yywd.vip')) {
    config.debug = false;
    baseURL = "https://huawei.api.v1.yywd.vip/";// beta测试环境接口域名
    oldPlatform = "http://huawei.yywd.vip/";// beta测试环境老项目地址
} else if (window.location.host.startsWith('test.ent.yywd.vip')) {
    config.debug = false;
    // axios.defaults.baseURL = "https://test.api.v1.yywd.vip/";// 云端测试环境接口域名
    baseURL = "https://test.api.ent.yywd.vip/";// 云端测试环境接口域名
    oldPlatform = "http://test.yywd.vip/";// 云端测试环境老项目地址
}

const Headers = {
    debug: false,//for test
    "request-from": "EnterpriseAdmin",
};

export default {
    BaseURL: baseURL,
    OldPlatform: oldPlatform,
    Headers
}